import styled from "styled-components";
import { device } from "../../utils/helpers/breakpoints";

export const Frame = styled.div`
  display: flex;

  & > aside {
    width: ${(props) => (props.isMessage ? "9rem" : "18.75rem")};
    top: 0;
    height: 100vh;
    @media ${device.tablet} {
      position: fixed !important;
    }
  }

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: auto;
  }
`;
